import { render, staticRenderFns } from "./newsEdit.vue?vue&type=template&id=27add218&scoped=true"
import script from "./newsEdit.vue?vue&type=script&lang=js"
export * from "./newsEdit.vue?vue&type=script&lang=js"
import style0 from "./newsEdit.vue?vue&type=style&index=0&id=27add218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27add218",
  null
  
)

export default component.exports